import template from './modal.html';
import { MessageModalController as controller } from './modal.controller';
import { GoModalSettings } from '../go-modal-bootstrap.factory';
import type { Bindings } from './modal.controller';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface MessageModalSettings extends GoModalSettings {
	modalData: Bindings;
}

/* @ngInject */
export class MessageModal {
	/* @ngInject */
	constructor (private goModalBootstrap) {}

	public open (options) {
		options.template = template;
		options.controller = controller;
		options.windowClass = options.name = 'message-modal';
		options.keyboard = false;
		options.backdrop = 'static';
		options.controllerAs = '$ctrl';
		options.bindToController = true;
		options.goreact = true; // For new modal styles
		options.modalData = {
			...(options.modalData ?? {}),
			dialogTitleId: options.modalData?.title == null
				? options.modalData?.dialogTitleId
				: options.modalData?.dialogTitleId ?? `message-modal-title-${UniqueIdGeneratorUtil.getId()}`
		};
		return this.goModalBootstrap.open(options);
	}
}
